import React, { useEffect, useMemo, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import CustomSelect from '../../common/customSelect/CustomSelect';
import CustomFormLabel from '../../common/form-label/CustomFormLabel ';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/system';
import SelectWebformField from '../../webForms/SelectWebformField';
import axios from 'axios';
import configs from '../../../configs/config';


const getTicketAdditionalWebForm = (type: string = "TicketAdditionalField", callback?: any, ticketTypeId?: any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios(`${configs.BASE_URL}/webform?Type=TicketAdditionalField&ticketTypeId=${ticketTypeId}`);
      const list: any = []
      response?.data?.map((i: any) => {
        if (i.type === type) { list.push({ ...i, value: i.name, label: i.name }) }
      })
      try {
        callback(list)
      } catch (e: any) {
        console.log('e')
      }
    } catch (error: any) {
      return console.log(error);
    }
  };
};

function TicketAdditionalField({ ticketTypeId, setAdditionalFields, additionalFieldserror={}, savedsetAdditionalFields={}, col=6, idNamespace="", wrapperClass="", showTitle=false }: any) {
  const [data, setData] = useState([])
  const [records, setRecords] = useState<any>([])
  const [errValues, setErrValues] = useState<any>(additionalFieldserror);
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getTicketAdditionalWebForm("TicketAdditionalField", getWebFormCb, ticketTypeId))
  }, [ticketTypeId])
  const getWebFormCb = (data: any) => {
    setData(data.map((i: any) => {
      return i;
    }));
    setRecords(data)
    if(setAdditionalFields) setAdditionalFields(data);
    setErrValues({})
  }




 
  const webFormFields = useMemo(
    () => (
      <>{records[0]?.webformFieldList?.length > 0 && 
      <Box className={wrapperClass}>
        {showTitle && <Typography className="add-fields-subsec-title">Additional Fields</Typography>}
      <Grid container spacing={1}>
      {/* <> */}
      <>
        {records[0]?.webformFieldList?.map((i: any) => {
          const { fieldLabel, fieldId } = i;
          i.id = fieldLabel;

          return (
            <Grid item md={col} key={fieldId} >
              <Box className="webform-fields-holderd" sx={{width:'100%'}}>
                <SelectWebformField
                  block={i}
                  value={savedsetAdditionalFields?.[fieldLabel]}
                  idNamespace={idNamespace}
                  // editable={false}
                />
                {additionalFieldserror?.[fieldId] && (
                  <Typography variant="caption" color="error">
                    {additionalFieldserror[fieldId]}
                  </Typography>
                )}
              </Box>
            </Grid>
          );
        })}
         </> 
       </Grid>
      </Box>
      }</>
    ),
    [records, additionalFieldserror, savedsetAdditionalFields]
  );

  return <>{webFormFields}</>;
}

export default TicketAdditionalField;